import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';

@Component({
	selector: 'app-paginator',
	templateUrl: './paginator.component.html',
	styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent implements OnInit, OnDestroy {
	paginatorItems: Array<number> = [];

	@Input() event!: Observable<number>;

	reloadbuttonPage: Subject<number> = new Subject<number>();

	eventSubscription!: Subscription;
	itemsLengthTmp!: number;

	@Input()
	newstartpage = 0;

	@Input()
	currentPage = 1;

	@Input()
	set itemsLength(value: number) {
		this.itemsLengthTmp = value;
		this.currentPage = 1;
		this.paginatorItems = this.generateArray(this.itemsLength, this.itemsPerPage);
	}

	get itemsLength(): number {
		return this.itemsLengthTmp;
	}

	@Input()
	itemsPerPage = 1;

	@Output()
	pageEmitter = new EventEmitter<number>();

	ngOnInit(): void {
		this.paginatorItems = this.generateArray(this.itemsLength, this.itemsPerPage);
		if (this.event) {
			this.eventSubscription = this.event.subscribe((page) => {
				this.selectPage(page);
			});
		}
	}

	ngOnDestroy(): void {
		if (this.eventSubscription) {
			this.eventSubscription.unsubscribe();
		}
	}

	onNextPage(): void {
		if (this.currentPage + 1 <= Math.ceil(this.itemsLength / this.itemsPerPage)) {
			this.currentPage++;
			this.paginatorItems = this.generateArray(this.itemsLength, this.itemsPerPage, this.currentPage);
			this.pageEmitter.emit(this.currentPage);
		}
	}

	onPreviousPage(): void {
		if (this.currentPage - 1) {
			this.currentPage--;
			this.paginatorItems = this.generateArray(this.itemsLength, this.itemsPerPage, this.currentPage);
			this.pageEmitter.emit(this.currentPage);
		}
	}

	selectPage(pageNumber = 1): void {
		if (pageNumber === -1) {
			return;
		}
		this.currentPage = pageNumber;
		this.paginatorItems = this.generateArray(this.itemsLength, this.itemsPerPage, pageNumber);
		this.pageEmitter.emit(this.currentPage);
	}

	generateArray(total = 1, perPage = 1, currentPage = 1): number[] {
		const lastPage = Math.ceil(total / perPage);

		if (lastPage <= 6) {
			return Array(lastPage)
				.fill(0)
				.map((x, i) => i + 1);
		} else {
			let arrayResponse: number[] = [];
			const upperLimit = lastPage - 2;

			if (currentPage === 1 || currentPage <= 3) {
				arrayResponse = [1, 2, 3, -1, lastPage - 1, lastPage];
			} else if (currentPage > 3 && currentPage < upperLimit) {
				arrayResponse = [1, -1, currentPage, -1, lastPage - 1, lastPage];
			} else {
				arrayResponse = [1, 2, -1, lastPage - 2, lastPage - 1, lastPage];
			}
			return arrayResponse;
		}
	}
}
